import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../utils/dateUtils';
import { CouponServices } from './CouponServices';

const ExportAll = (props) => {
  const { paginationModel } = props;

  // Define custom headers and their corresponding data mapping
  const exportMapping = [
    {
      header: 'Coupon Id',
      value: (row) => `${row.id}`
    },
    {
      header: 'Title',
      value: (row) => `${row?.title}`
    },
    {
      header: 'Description',
      value: (row) => `${row?.description}`
    },
    {
      header: 'Coupon Code',
      value: (row) => `${row?.couponCode}`
    },
    {
      header: 'Coupon Type',
      value: (row) => `${row?.couponType}`
    },
    {
      header: 'couponValue',
      value: (row) => `${row?.couponValue}%`
    },
    {
      header: 'MinimumBookingAmt',
      value: (row) => `Rs. ${row?.minimumBookingAmt}`
    },
    {
      header: 'Maximum Discount',
      value: (row) => `Rs. ${row?.maximumDiscount}`
    },
    {
      header: 'Limit Per User',
      value: (row) => `${row?.limitPerUser}`
    },
    {
      header: 'Start Date',
      value: (row) => formatDateTime(row.startDate,'date')
    },
    {
      header: 'End Date',
      value: (row) => formatDateTime(row.endDate,'date')
    },
    {
      header: 'Status',
      value: (row) => {
        const isExpired = (endDate) => {
          if (!endDate) return false;
          
          const endDateObj = new Date(endDate);
          // Set time to 23:59:59 on end date
          endDateObj.setHours(23, 59, 59, 999);
          
          return endDateObj < new Date();
        };
        
        const expired = isExpired(row.endDate);
        
        return expired?'Expired': row.status?'Active':'In-Active'
      }
    },
    {
      header: 'User Specific',
      value: (row) => row?.selectedCustomers?.length>0? 'Yes' :'No'
    },
    {
      header: 'Creation Date',
      value: (row) => formatDateTime(row.createdAt)
    }
  ];

  const handleExportAllRows = async () => {
    try {
      Swal.fire({
        title: 'Exporting Data',
        text: 'Please wait while we prepare your download...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const listResponse = await CouponServices.exportCouponList({
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });

      // Transform data using custom mapping
      const exportData = listResponse.data.coupons.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Coupon-Report.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="ServiceExpert-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;